module.exports = __webpack_public_path__ + "static/media/PracticeDemo.13fed8ee.jpg";